import React from 'react'

import Table from 'react-bootstrap/Table';
import "./ugpg.css"
import Accordion from 'react-bootstrap/Accordion';

const PG = () => {
  return (
 <>
 
   <div className="ug-body">
   
   
   <Accordion>
   <Accordion.Item eventKey="0">
        <Accordion.Header> <div className="batch">BATCH 2023</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Dharmendra Kumar</td>
          <td>2302105004</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Pratik Prakash Pawar</td>
          <td>2302105005</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Snehungsu Sahana</td>
          <td>2302105006</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Sourabh Goswami</td>
          <td>2302105008</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Dharavath Venkatesh</td>
          <td>2302105009</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Akash Kumar</td>
          <td>2302105016</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Anik Chatterjee</td>
          <td>2302105017</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Gaurav Rajput</td>
          <td>2302105018</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Mohit Tiwari</td>
          <td>2302105020</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>S. Sridharan</td>
          <td>2302105021</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Adi Raj</td>
          <td>2302105022</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Aditya Dattu Girge</td>
          <td>2302105023</td>
        
        </tr>

       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
   <Accordion.Item eventKey="1">
        <Accordion.Header> <div className="batch">BATCH 2022</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Rishav Sharma</td>
          <td>2202105001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Neha</td>
          <td>2202105002</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Shantanu Dilip Gagare</td>
          <td>2202105004</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Shaikh Azaharuddin</td>
          <td>2202105005</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Shubham Garg</td>
          <td>2202105006</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Prosenjit Mondal</td>
          <td>2202105008</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Shubham Jain</td>
          <td>2202105009</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>M Sudharsana Raj</td>
          <td>2202105020</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Ramamoorthy V</td>
          <td>2202105021</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Mohammed Musaib Mohd</td>
          <td>2202105022</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Abhinav Singhal</td>
          <td>2202105024</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Kumar Aman</td>
          <td>2202105025</td>
        
        </tr>

       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
   <Accordion.Item eventKey="2">
        <Accordion.Header> <div className="batch">BATCH 2021</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Praveen Rautela</td>
          <td>2102105002</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Muppirala Subrahmanya</td>
          <td>2102105003</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Akula Surya Teja</td>
          <td>2102105004</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Samriddhi Saxena</td>
          <td>2102105005</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Namrata Sarania</td>
          <td>2102105016</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Sajid Qureshi</td>
          <td>2102105017</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Ashit Palai</td>
          <td>2102105018</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Nagilla Pranay Reddy</td>
          <td>2102105020</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Siddhant Sharma</td>
          <td>2102105021</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Aayush Pathak</td>
          <td>2102105022</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Yogendra Sharma</td>
          <td>2102105023</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Nitin Sehgal</td>
          <td>2102105024</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>Sahil Kumar</td>
          <td>2102105026</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Rajeev Kumar</td>
          <td>2102105027</td>
        
        </tr>

       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header><div className="batch">BATCH 2020</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Abhinav Maurya</td>
          <td>2002105001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Akash Kankane</td>
          <td>2002105002</td>
       
        </tr>
        <tr>
          <td>3</td>
          <td>Bhaskar Singh Chouhan</td>
          <td>2002105003</td>
       
        </tr>
        <tr>
          <td>4</td>
          <td>Chhavi Shivhare</td>
          <td>2002105005</td>
       
        </tr>
        <tr>
          <td>5</td>
          <td>D Yashwanth Kumar Reddy</td>
          <td>2002105006</td>
       
        </tr>
        <tr>
          <td>6</td>
          <td>Diwakar Singh</td>
          <td>2002105008</td>
       
        </tr>
        <tr>
          <td>7</td>
          <td>Hari Narayan Vasavan</td>
          <td>2002105009</td>
       
        </tr>
        <tr>
          <td>8</td>
          <td>Jhantu Dhawria</td>
          <td>2002105010</td>
       
        </tr>
        <tr>
          <td>9</td>
          <td>Neha Shakya</td>
          <td>2002105011</td>
       
        </tr>
        <tr>
          <td>10</td>
          <td>Omkar Mishri Singh</td>
          <td>2002105012</td>
       
        </tr>
        <tr>
          <td>11</td>
          <td>Piyush Meena</td>
          <td>2002105013</td>
       
        </tr>
        <tr>
          <td>12</td>
          <td>Abhishek Kumar Sahu</td>
          <td>2002105016</td>
       
        </tr>
        <tr>
          <td>13</td>
          <td>Gaddam Shiva Kumar</td>
          <td>2002105017</td>
       
        </tr>
        <tr>
          <td>14</td>
          <td>Jani Raj Jayeshkumar</td>
          <td>2002105018</td>
       
        </tr>
        <tr>
          <td>15</td>
          <td>Lekhana Chandran</td>
          <td>2002105019</td>
       
        </tr>
        <tr>
          <td>16</td>
          <td>Naveen L</td>
          <td>2002105020</td>
       
        </tr>
        <tr>
          <td>17</td>
          <td>Nismath V S</td>
          <td>2002105021</td>
       
        </tr>
        <tr>
          <td>18</td>
          <td>Satyam Singh</td>
          <td>2002105022</td>
       
        </tr>
        <tr>
          <td>19</td>
          <td>Shubham Garg</td>
          <td>2002105024</td>
       
        </tr>
        <tr>
          <td>20</td>
          <td>Suman Dutta</td>
          <td>2002105026</td>
       
        </tr>
        <tr>
          <td>21</td>
          <td>Venkata Sandeep Kumar Devadula</td>
          <td>2002105027</td>
       
        </tr>
        
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="4">
        <Accordion.Header><div className="batch">BATCH 2019</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Harsha Rajput</td>
          <td>1902105001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Shivam Karoliya</td>
          <td>1902105002</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Divyanshu Gupta</td>
          <td>1902105004</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Vishal Prajapati</td>
          <td>1902105005</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Abhishek Kumar Jaiswal</td>
          <td>1902105006</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Praveen Kuamr</td>
          <td>1902105007</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Pallavi Singh</td>
          <td>1902105008</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Neelesh Singh</td>
          <td>1902105010</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Kaushal Ganwar</td>
          <td>1902105011</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Anurag Singh Chauhan</td>
          <td>1902105013</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Arindom A Baruah</td>
          <td>1902105015</td>
        
        </tr>
        <tr>
          <td>12</td>
          <td>Raineesh Babu Kp</td>
          <td>1902105016</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>Deepansh Chourasiya</td>
          <td>1902105017</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Ghanta Anurag</td>
          <td>1902105018</td>
        
        </tr>
        <tr>
          <td>15</td>
          <td>Rohan Jain</td>
          <td>1902105020</td>
        
        </tr>
        <tr>
          <td>16</td>
          <td>Pushpendra Sharde</td>
          <td>1902105021</td>
        
        </tr>
        <tr>
          <td>17</td>
          <td>Sakshi Mahloniya</td>
          <td>1902105022</td>
        
        </tr>
        <tr>
          <td>18</td>
          <td>Akanksha Sharma</td>
          <td>1902105023</td>
        
        </tr>
       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5">
        <Accordion.Header><div className="batch">BATCH 2018</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Ankit Solanki</td>
          <td>1802105001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Shadab Ali Ahmad</td>
          <td>1802105002</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Farhan Ali Ahmad</td>
          <td>1802105003</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Rishikesh Darshan</td>
          <td>1802105005</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Shubham Vasant Gaidhani</td>
          <td>1802105006</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Shardeshu Pandey</td>
          <td>1802105007</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Ekta Majhi</td>
          <td>1802105008</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Sharik Akhtar</td>
          <td>1802105009</td>
        
        </tr>
        <tr>
          <td>9</td>
          <td>Manish Kumar Tiwari</td>
          <td>1802105010</td>
        
        </tr>
        <tr>
          <td>10</td>
          <td>Manish Badole</td>
          <td>1802105012</td>
        
        </tr>
        <tr>
          <td>11</td>
          <td>Akshaya Kumar Jain</td>
          <td>1802105013</td>
        </tr>
        <tr>
          <td>12</td>
          <td>Ankit Kumar Singh</td>
          <td>1802105014</td>
        
        </tr>
        <tr>
          <td>13</td>
          <td>Ashok Kumar</td>
          <td>1802105015</td>
        
        </tr>
        <tr>
          <td>14</td>
          <td>Chaitanya Vishwakarma</td>
          <td>1802105016</td>
        
        </tr>
        <tr>
          <td>15</td>
          <td>Darshan Dange</td>
          <td>1802105017</td>
        
        </tr>
        <tr>
          <td>16</td>
          <td>Dheeraj Kumar</td>
          <td>1802105018</td>
        
        </tr>
        <tr>
          <td>17</td>
          <td>Ghadse Pratik Parag</td>
          <td>1802105019</td>
        
        </tr>
        <tr>
          <td>18</td>
          <td>Janmejai Sharma</td>
          <td>1802105020</td>
        
        </tr>
        <tr>
          <td>19</td>
          <td>Mohammed Mubarak</td>
          <td>1802105022</td>
        
        </tr>
        <tr>
          <td>20</td>
          <td>Reeturaj Tamuly</td>
          <td>1802105023</td>
          
        </tr>
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="6">
        <Accordion.Header><div className="batch">BATCH 2017</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Avi Jain</td>
          <td>1702105001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Deepak Paliwal</td>
          <td>1702105002</td>
       
        </tr>
        <tr>
          <td>3</td>
          <td>Hariom Sharma</td>
          <td>1702105003</td>
       
        </tr>
        <tr>
          <td>4</td>
          <td>Harsh vaid</td>
          <td>1702105004</td>
       
        </tr>
        <tr>
          <td>5</td>
          <td>Mohit Deshpande</td>
          <td>1702105005</td>
       
        </tr>
        <tr>
          <td>6</td>
          <td>Narendra Anjana</td>
          <td>1702105006</td>
       
        </tr>
        <tr>
          <td>7</td>
          <td>Parmar Kaushal Harishkumar</td>
          <td>1702105007</td>
       
        </tr>
        <tr>
          <td>8</td>
          <td>Santosh Bimli</td>
          <td>1702105008</td>
       
        </tr>
        <tr>
          <td>9</td>
          <td>Shubham Choudhary</td>
          <td>1702105009</td>
       
        </tr>
        <tr>
          <td>10</td>
          <td>Vikesh Kumar</td>
          <td>1702105010</td>
       
        </tr>
       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="7">
        <Accordion.Header><div className="batch">BATCH 2016</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Abhinav Sharma</td>
          <td>1602181001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Ananya Tiwari</td>
          <td>1602181002</td>
       
        </tr>
        <tr>
          <td>3</td>
          <td>Milind Choubey</td>
          <td>1602181003</td>
       
        </tr>
        <tr>
          <td>4</td>
          <td>Pydi Yeswanth Sai</td>
          <td>1602181005</td>
       
        </tr>
        <tr>
          <td>5</td>
          <td>Rohit R.S.</td>
          <td>1602181006</td>
       
        </tr>
        <tr>
          <td>6</td>
          <td>Tulika Dixit</td>
          <td>1602181007</td>
       
        </tr>
        <tr>
          <td>7</td>
          <td>Garima Dixit</td>
          <td>1602181009</td>
       
        </tr>
        <tr>
          <td>8</td>
          <td>Milind Kumar</td>
          <td>1602181010</td>
       
        </tr>
       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="8">
        <Accordion.Header><div className="batch">BATCH 2015</div> </Accordion.Header>
        <Accordion.Body>
        <div className='ug-tble'>
    <Table striped>
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th> Name</th>
          <th>Roll No.</th>
        
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Ashima Singh</td>
          <td>1502181001</td>
        
        </tr>
        <tr>
          <td>2</td>
          <td>Punkit Sood</td>
          <td>1502181002</td>
        
        </tr>
        <tr>
          <td>3</td>
          <td>Rahul Raj Khare</td>
          <td>1502181003</td>
        
        </tr>
        <tr>
          <td>4</td>
          <td>Rahul Singh Mourya</td>
          <td>1502181004</td>
        
        </tr>
        <tr>
          <td>5</td>
          <td>Rituraj Verma</td>
          <td>1502181006</td>
        
        </tr>
        <tr>
          <td>6</td>
          <td>Sandeep jain</td>
          <td>1502181007</td>
        
        </tr>
        <tr>
          <td>7</td>
          <td>Sumit Kumar Barange</td>
          <td>1502181009</td>
        
        </tr>
        <tr>
          <td>8</td>
          <td>Inderpal Singh Pasrija</td>
          <td>1502181011</td>
        
        </tr>
       
        
      </tbody>
    </Table>
    </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    
   </div>
   
 </>
  )
}

export default PG
